import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseProgressLinear = _resolveComponent("BaseProgressLinear")!

  return (_openBlock(), _createBlock(_component_BaseProgressLinear, {
    class: "FarmSliderProgress",
    value: _ctx.startProgress ? 100 : 0,
    "transition-duration": '6s',
    "animation-timing-function": "linear"
  }, null, 8, ["value"]))
}